import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCityDetails } from "../../redux/state/citiesReduser/cities.redusers";
import { fetchCityById } from "../../redux/state/citiesReduser/citiesFetchService";
import { useParams } from "react-router-dom";
import { Box, Card, Grid } from "@mui/material";
import { motion } from "framer-motion";
import ProductSlider from "../ProductsSlider/ProductsSlider";
import styles from "./CityDetails.styled";
import { scrollToTop } from "../../srevices/scrollToTop";
import ProductVariants from "../ProductVariants/ProductVariants";

function CityDetails() {
  const { cityId } = useParams();
  const dispatch = useDispatch();
  const cityDetails = useSelector(selectCityDetails);
  const [activeVariant, setActiveVariant] = useState(null);

  const toggleDistricts = (variantId) => {
    setActiveVariant((prev) => (prev === variantId ? null : variantId));
  };

  useEffect(() => {
    dispatch(fetchCityById(cityId));
    scrollToTop();
  }, [cityId, dispatch]);

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      sx={{
        minHeight: "100vh",
        backgroundColor: "transparent",
        padding: 2,
      }}
    >
      <Grid container {...styles.gridContainer}>
        {cityDetails?.products.map(
          ({ _id, artkl, name, img, variants }, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={_id}>
              <motion.div
                initial={{ x: index % 2 === 0 ? -100 : 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card sx={styles.card}>
                  <ProductSlider
                    images={img}
                    productLink={`/products/${artkl}`}
                  />
                  <ProductVariants
                    product={{ name, variants, img, nameCity: cityDetails.name }}
                    toggleDistricts={toggleDistricts}
                    activeVariant={activeVariant}
                  />
                </Card>
              </motion.div>
            </Grid>
          )
        )}
      </Grid>
    </Box>
  );
}

export default CityDetails;
